export default __webpack_public_path__ + "static/AmericanaStd-Roman-b2396efacfc44a8775b8d8f5f917a86c.woff2";